import React from 'react';
import { NextPage } from 'next';
import { HomePageContentLayout } from '@/finsight/ui/common/components/ContentLayouts';
import Homepage from '@/finsight/ui/components/staticPages/Homepage';
import withApplicationProps from '@/finsight/application/withApplicationProps';

export const getServerSideProps = withApplicationProps(() => ({
  props: {},
}));

type TProps = {};

const Home: NextPage<TProps, any> = () => (
  <HomePageContentLayout>
    <Homepage />
  </HomePageContentLayout>
);

export default Home;
